import { Component, OnInit, Input, HostListener, Output, EventEmitter, ElementRef} from '@angular/core';
import { AllSecurityRecords } from '../../models/custom-multiselect.model';
import {emtrConstant} from '../../constants/emtrConstants';
import {RuleService} from '../../services/rule-service/rule.service';

@Component({
  selector: 'tr-custom-multiselect',
  templateUrl: './custom-multiselect.component.html'
})
export class CustomMultiselectComponent implements OnInit {

  getConstant = emtrConstant;
    showDropDown = false;
    selectAllCheckbox: boolean;
    selectedCategories: any = [];
    showSelectedArray: any = [];
    securityDropDownData: any = [];
    highlightAll = false;
    defaultAllRecords: any = AllSecurityRecords;
    checkAllArray: any = [];
    sharedEnv: any;
    /*Emitting the selected Values to Parent Component */
    @Input() selectedValues: any[] = [];
    @Output() emitSelectedvalues: EventEmitter<string[]> = new EventEmitter<string[]>();
    @Input() isDisabled: boolean;

    constructor(private ef: ElementRef, private ruleService: RuleService) {

    }
    @HostListener('document:click', ['$event'])
    onClick(event) { /* Capture the Click Event outside the function */
        if (!this.ef.nativeElement.contains(event.target)) {
            this.showDropDown = false;
        }
    }

    ngOnInit() {
        /* Fetching the Security Types from the API */
        this.ruleService.getAssettypes().subscribe((datas: any) => {
            this.securityDropDownData = datas.data;
            this.securityDropDownData.sort((a, b) => (a.desc > b.desc) ? 1 : ((b.desc > a.desc) ? -1 : 0));
            this.checkAllArray = this.securityDropDownData;
            this.selectedCategories = [];
            /* Pushing the selected securities in rule step 2 to Advance search popup obtained from selectedValues input */
            if (this.selectedValues && this.selectedValues.length > 0) {
                this.selectedCategories = [...this.selectedValues];
                this.showSelectedArray = [...this.selectedValues];
                /* If All values are selected in rule step 2, adding them to the showSelectedArray */
                if (this.selectedValues.length === this.checkAllArray.length) {
                    this.addAllToArray();
                }
            }
            /* Selecting All Securities by default */
            else {
                this.selectedCategories = this.checkAllArray;
                this.addAllToArray();
            }
            this.emitSelectedvalues.emit(this.selectedCategories);
        });
    }

    selectSecurity() {     /* Clicking Div to Open and close the DropDown */
        return this.showDropDown = !this.showDropDown;
    }

    /* DropDown clicking All Functionality */
    selectedAll() {
        if (this.selectAllCheckbox) {     /* Select-All Check Scenario */
            this.selectedCategories = this.checkAllArray;
            this.addAllToArray();
        } else {
            /* Select-All UnCheck Scenario */
            this.unCheckSelectAll();
            this.highlightAll = false;
        }
        /* Emitting the Selected Categories to Parent Component */
        this.emitSelectedvalues.emit(this.selectedCategories);
    }

    /* Select-All UnCheck Scenario */
    unCheckSelectAll() {
        this.selectedCategories = [];
        this.showSelectedArray = [];
        this.emitSelectedvalues.emit(this.selectedCategories);
    }
    /* Checked/Unchecked Checkbox in DropDown Functionality */
    checkboxChecked() {
        /* Pushing Whole array for select all checkbox checked/unchecked Functionality*/
        /* Verifying Whole Array and SelectedCategories array both are same*/
        if ([...this.checkAllArray].sort().toString() === [...this.selectedCategories].sort().toString()) {
            this.addAllToArray();
        } 
        else {
            this.showSelectedArray = this.selectedCategories;
            this.selectAllCheckbox = false;
            this.highlightAll = false;
        }

        this.emitSelectedvalues.emit(this.selectedCategories);
    }

    /* Highlighting the checked dropdown list */
    getClassByValue(value) {
        return (this.selectedCategories.filter(data => data.code === value).length !== 0);
    }

    /*Pushing defaultAllRecords object When All items are selected*/
    addAllToArray() {
        this.showSelectedArray = [];      
        this.showSelectedArray.push(this.defaultAllRecords);
        this.showSelectedArray.sort();
        this.selectAllCheckbox = true;
        this.highlightAll = true;
    }

}
